module.exports = __webpack_public_path__ + "static/media/wave-grc-mob-2.acf073cd.svg";